import React, { createContext, useState, ReactNode, useEffect } from 'react';
import { DisplayNotificationContextType } from './types/diplayNotificationContextType';
import { DisplayNotification, DisplayNotificationType } from '../models/DisplayNotification';
import { v4 as uuidv4 } from 'uuid';

export const DisplayNotificationContext = createContext<DisplayNotificationContextType | undefined>(undefined);

export const DisplayNotificationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [notifications, setNotifications] = useState<DisplayNotification[]>([]);



    const addNotification = (notification: DisplayNotification, expires: boolean = false) => {
        notification.id = uuidv4();
        if (expires) notification.durationMs = 3000;
        setNotifications((prev) => [...prev, notification]);

        if (notification.durationMs) {
            setTimeout(() => {
                setNotifications((prev) => prev.filter((n) => n.id !== notification.id));
            }, notification.durationMs);
        }
    };

    const addSuccessNotification = (message: string, header?: string) => {
        addNotification({ type: DisplayNotificationType.SUCCESS, header, message, durationMs: 3000 });
    }

    const removeNotification = (id: string) => {
        setNotifications(notifications.filter((notification) => notification.id !== id));
    };

    const addErrorNotification = (message: string, header?: string, onAction?: () => void, actionText?: string) => {
        addNotification({ type: DisplayNotificationType.ERROR, header, message, onAction, actionText });
    }

    return (
        <DisplayNotificationContext.Provider value={{
            notifications,
            addNotification,
            addSuccessNotification,
            addErrorNotification,
            removeNotification
        }}>
            {children}
        </DisplayNotificationContext.Provider>
    );
};